import React from 'react';
import { connect } from "react-redux";

function ConnectedProgress({ stateAutomix, currentAutomix }) {
  const progress = currentAutomix.mixingprogress ? Math.round(currentAutomix.mixingprogress) : 0;
  return (stateAutomix === 'mixing' || stateAutomix === 'skipping') ? (
    <div className={`cf-state-nav-title-v2 flexRow`}>
      <span className={`type-regular type-secondary`} >{(progress >= 1) ? 'Transition' : 'Loading...'}</span>
      {(progress >= 1) && <span style={{color: '#C2C2C2', width: 45}}>{`${progress}%`}</span> }
    </div>
  ) : null
}

const Progress = connect(
  state => ({
    stateAutomix: state.stateAutomix,
    currentAutomix: state.currentAutomix,
  })
)(ConnectedProgress);

export default Progress;
